import styled from 'styled-components';
import { screen } from '@/helpers/screen';

//miranda tokens
import { getToken } from '@loadsmart/miranda-tokens';

import { Wrapper as BaseWrapper } from '/components/Grid/Content';

export const SectionWrapper = styled.section`
  padding: 40px 0;
  background-color: rgb(255, 255, 255);
  text-align: center;

  ${screen.md} {
    padding: 50px 0;
  }

  ${screen.lg} {
    padding: 80px 0;
  }

  ${screen.xxlg} {
    padding: 66px 0;
  }
`;

export const Wrapper = styled(BaseWrapper)`
  justify-content: center;
  align-items: center;
  padding: 0 0 36px 0;

  ${screen.md} {
    align-items: start;
    padding-bottom: 0px;
    padding-right: 28px;
  }

  ${screen.lg} {
    padding-right: 40px;
  }

  ${screen.xxlg} {
    padding-right: 50px;
  }
`;

export const Title = styled.h2`
  margin: 0px;
  font-family: ${getToken('platform-font-title')};
  color: rgb(${getToken('color-text-primary')});
  font-weight: ${getToken('font-weight-bold')};
  font-size: 26px;
  line-height: 39px;
  text-align: center;

  br {
    display: none;
  }

  ${screen.md} {
    text-align: left;
  }

  ${screen.lg} {
    font-size: 38px;
    line-height: 47.5px;

    br {
      display: block;
    }
  }

  ${screen.xxlg} {
    font-size: 48px;
    line-height: 60px;
  }
`;

export const Content = styled.p`
  font-family: ${getToken('platform-font-default')};
  color: rgb(${getToken('color-text-primary')});
  font-weight: ${getToken('font-weight-regular')};
  font-size: 14px;
  line-height: 21px;
  text-align: center;
  margin: 28px 0 36px;

  ${screen.md} {
    text-align: left;
  }

  ${screen.lg} {
    font-size: 20px;
    line-height: 36px;
    margin: 36px 0;
  }

  ${screen.xxlg} {
    font-size: 20px;
    line-height: 36px;
    margin: 40px 0 36px;
  }
`;

export const Picture = styled.picture`
  display: inline-block;
  box-sizing: border-box;
  margin: auto;

  ${screen.md} {
    padding: 0;
  }

  img,
  source {
    max-width: 100%;
    height: auto;
    margin: auto;

    ${screen.md} {
      min-width: 376px;
    }

    ${screen.lg} {
      min-width: 508px;
    }

    ${screen.xxlg} {
      min-width: 702px;
    }
  }
`;

export const SectionPanel = styled.div`
  display: flex;
  flex-direction: column-reverse;

  ${screen.md} {
    flex-direction: row-reverse;
  }
`;
